import { useState } from "react"
import { Check, Copy as CopyIcon } from "lucide-react"

import { copyContent } from "@/lib/copyContent"
import { Button } from "../ui/button"

interface CopyButtonProps {
  value: string
  iconOnly?: boolean
}

export const CopyButton = ({ value, iconOnly = false }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    const success = await copyContent(value)
    if (!success) return

    setCopied(true)
    window.setTimeout(() => setCopied(false), 1600)
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size={iconOnly ? "icon" : "sm"}
      className={iconOnly ? "h-8 w-8" : "gap-1.5 px-2.5"}
      onClick={handleCopy}
      aria-label={iconOnly ? (copied ? "Copied" : "Copy") : undefined}
    >
      {copied ? (
        <Check className="size-4 text-emerald-500" />
      ) : (
        <CopyIcon className="size-4 text-muted-foreground" />
      )}
      {iconOnly ? null : copied ? "Copied" : "Copy"}
    </Button>
  )
}
